export enum HookKind {
    START = 0,
    EVENT = 1,
    END = 2
}
